import React from "react";
import {
  Drawer,
  Row,
  Col,
  Card,
  Statistic,
  Typography,
  Tag,
  Image,
} from "antd";
import {
  ShoppingOutlined,
  TeamOutlined,
  DollarOutlined,
  //SmileOutlined,
} from "@ant-design/icons";
import moment from "moment-timezone";
import { cardStyle } from "./elements";
import { GET_ORDER } from "../requests";
import { useQuery } from "@apollo/client";
import TitleSubtitle from "../../../components/titleSubtitle";
import { paymentStatus } from "../../../utils/constants";

const { Text } = Typography;

interface ViewDetailModalProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  selectedOrder: any;
}

const ViewDetailModal: React.FC<ViewDetailModalProps> = ({
  visible,
  setVisible,
  selectedOrder,
}) => {
  const handleCancel = () => {
    setVisible(false);
  };

  const { data } = useQuery(GET_ORDER, {
    variables: {
      id: selectedOrder?.id,
    },
    skip: !visible,
  });

  const events = data?.order?.events ?? [];
  const payment = data?.order?.payment ?? null;
  const location = data?.order?.location ?? null;

  const getFirstEventDate = (type: string) => {
    const event = events.find((event: { type: string; }) => event.type === type);
    return event ? moment(event.changedAt).tz("America/Mexico_City").format("lll") : "-";
  };

  const createdDate = getFirstEventDate("programmed");
  const pickupTime = moment(data?.order?.pickupTime).tz("America/Mexico_City").format("lll");
  const preparedTime = getFirstEventDate("prepared");
  const completeTime = moment(data?.order?.dropOffTime).tz("America/Mexico_City").format("lll");

  const createdMoment = events.find((e) => e.type === "created")
    ? moment(events.find((e) => e.type === "created").changedAt).tz("America/Mexico_City")
    : null;

  const preparedMoment = events.find((e) => e.type === "prepared")
    ? moment(events.find((e) => e.type === "prepared").changedAt).tz("America/Mexico_City")
    : null;

  const completeMoment = data?.order?.dropOffTime
    ? moment(data.order.dropOffTime).tz("America/Mexico_City")
    : null;

  const pickupDiffTime =
    preparedMoment && completeMoment
      ? completeMoment.diff(preparedMoment, "minutes")
      : "-";

  const preparedDiffTime =
    createdMoment && preparedMoment
      ? preparedMoment.diff(createdMoment, "minutes")
      : "-";

  return (
    <>
      <Drawer
        title="Detalle de la Orden"
        visible={visible}
        onClose={handleCancel}
        width={"60vw"}
      >
        <Row gutter={[16, 16]} style={{ marginBottom: 24 }}>
          <Col xs={24} sm={12} lg={6}>
            <Card style={{ ...cardStyle }}>
              <Statistic
                title="Preparacion"
                value={`${preparedDiffTime} Min`}
                prefix={<ShoppingOutlined style={{ color: "#e67e22" }} />}
              />
            </Card>
          </Col>
          <Col xs={24} sm={12} lg={6}>
            <Card style={{ ...cardStyle }}>
              <Statistic
                title="PickUp"
                value={`${pickupDiffTime} Min`}
                prefix={<TeamOutlined style={{ color: "#3498db" }} />}
              />
            </Card>
          </Col>
          <Col xs={24} sm={12} lg={6}>
            <Card style={{ ...cardStyle }}>
              <Statistic
                title="Ingresos "
                value={data?.order?.price}
                precision={2}
                prefix={<DollarOutlined style={{ color: "#2ecc71" }} />}
              />
            </Card>
          </Col>
          {/*  <Col xs={24} sm={12} lg={6}>
            <Card style={{ ...cardStyle }}>
              <Statistic
                title="Rating"
                value={4.8}
                precision={1}
                suffix="/5"
                prefix={<SmileOutlined style={{ color: "#f1c40f" }} />}
              />
            </Card>
          </Col> */}
        </Row>
        <Card
          style={{
            width: "100%",
            borderRadius: 10,
            overflow: "hidden",
            boxShadow: "rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px",
          }}
          bodyStyle={{ padding: 20 }}
        >
          <Row style={{ justifyContent: "space-between" }}>
            <div>
              <Text style={{ fontSize: 18,
                fontWeight: 800 }}>
                {data?.order?.client?.user?.firstName}{" "}
                {data?.order?.client?.user?.lastName}
              </Text>
              <br />
              <div style={{ marginTop: 5 }}>
                <Text strong>Comprado :</Text>
                <Tag style={{ marginLeft: 10 }} color="orange">
                  {createdDate}
                </Tag>
                <br />
                <div style={{ marginTop: 5 }}>
                  <Text strong> Agendado :</Text>
                  <Tag style={{ marginLeft: 10 }} color="blue">
                    {pickupTime}
                  </Tag>
                </div>
                <div style={{ marginTop: 5 }}>
                  <Text strong> Preparado : </Text>
                  <Tag style={{ marginLeft: 10 }} color="green">
                    {preparedTime}
                  </Tag>
                </div>
                <div style={{ marginTop: 5 }}>
                  <Text strong>Entregado : </Text>
                  <Tag style={{ marginLeft: 10 }} color="green">
                    {completeTime}
                  </Tag>
                </div>
              </div>
            </div>
            {/* <div style={{ paddingTop: 25 }}>
              <Tag color="green">A Tiempo</Tag>
              <br />
              <Text style={{ color: "grey",
                fontWeight: "700" }}>
                Listo 5 minutos antes
              </Text>
              <br />
              <br />
              <Text style={{ fontWeight: "700" }}>Preparado : Jorge Abdo</Text>
              <br />
              <Text style={{ fontWeight: "700" }}>Entregado : Jorge Abdo</Text>
            </div> */}
            <div>
              <Text style={{ fontSize: 18,
                fontWeight: 800 }}>
                {location?.name}
              </Text>
              <br />
              <Image
                style={{ width: 120,
                  height: 120,
                  borderRadius: 10 }}
                src={location?.img}
              />
            </div>
          </Row>
        </Card>
        <br />
        <Card
          style={{
            width: "100%",
            borderRadius: 10,
            overflow: "hidden",
            boxShadow: "rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px",
          }}
          bodyStyle={{ padding: 10 }}
        >
          <Text style={{ fontSize: 18,
            fontWeight: 800 }}>
            ({data?.order?.lineItems?.length}) Productos
          </Text>
          <br />
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "12px",
              marginTop: 10,
              maxWidth: "800px",
            }}
          >
            {data?.order?.lineItems?.map((item, index) => {
              return (
                <div
                  key={`${item.product?.product?.name}-${index}`}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    padding: "10px",
                    borderRadius: "8px",
                    border: `1px solid black`,
                    minWidth: "200px",
                    flex: "1 1 30%",
                    maxWidth: "200px",
                  }}
                >
                  {item.product?.img && (
                    <Image
                      src={item.product?.img}
                      width={40}
                      height={40}
                      style={{
                        objectFit: "cover",
                        borderRadius: "6px",
                      }}
                      preview={false}
                    />
                  )}
                  <div>
                    <Text
                      strong
                      style={{
                        fontSize: "14px",
                        lineHeight: "1.2",
                        whiteSpace: "normal",
                        wordWrap: "break-word",
                        overflow: "hidden",
                        display: "-webkit-box",
                        WebkitBoxOrient: "vertical",
                        WebkitLineClamp: 2,
                        textAlign: "left",
                      }}
                    >
                      {item.product?.product?.name}
                    </Text>

                    <Text
                      style={{ color: "grey",
                        fontWeight: "800",
                        fontSize: 11 }}
                    >
                      QTY:{item?.qty}
                    </Text>
                  </div>
                </div>
              );
            })}
          </div>
        </Card>
        <br />
        <Card
          style={{
            width: "100%",
            borderRadius: 10,
            overflow: "hidden",
            boxShadow: "rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px",
          }}
          bodyStyle={{ padding: 10 }}
        >
          {payment ? (
            <>
              <Text style={{ fontSize: 18,
                fontWeight: 800 }}>
                Informacion de Pago
              </Text>
              <TitleSubtitle
                title="Metodo de Pago"
                subtitle={`${payment.paymentMethod.brand} terminación ${payment.paymentMethod.last4}`}
              />
              <TitleSubtitle
                title="Tipo de Tarjeta"
                subtitle={payment.paymentMethod.type}
              />
              <TitleSubtitle
                title="Fecha de Pago"
                subtitle={moment(payment.createdAt).tz("America/Mexico_City").format("lll")}
              />
              <TitleSubtitle
                title="Estatus"
                subtitle={paymentStatus[payment.status].name}
              />
            </>
          ) : <Text style={{ fontSize: 18,
            fontWeight: 800 }}>Sin información de pago</Text>}
        </Card>
      </Drawer>
    </>
  );
};

export default ViewDetailModal;
